import MyOrdersLayout from 'layout/MyOrdersLayout'
import OrderTrackingContainer from 'containers/OrderTrackingBaseComponent/MyOrders'
import { userToken } from 'utils/oauth'

export async function getServerSideProps ({ req, res }) {
  const token = await userToken(req, res)

  if (!token) {
    return {
      redirect: {
        permanent: false,
        destination: '/auth/login'
      }
    }
  }

  return {
    props: {}
  }
}

export default function Index (props) {
  return (
    <MyOrdersLayout>
      {() => <OrderTrackingContainer {...props} />}
    </MyOrdersLayout>
  )
}
